export const dropDownItems = {
  en: [
    {
      name: 'Nature-based solutions',
      href: '/about-nbs',
    },
    {
      name: 'International goals and obligations',
      href: '/about-international-goals',
    },
    {
      name: 'Nordic policy landscape',
      href: '/about-nordic-policy-landscape',
    },
  ],
  fi: [
    {
      name: 'Luontopohjaiset ratkaisut',
      href: '/tietoja-luontopohjaiset-ratkaisut',
    },
    {
      name: 'Kansainväliset tavoitteet ja velvoitteet',
      href: '/tietoja-kansainvaliset-tavoitteet-ja-velvoitteet',
    },
    {
      name: 'Pohjoismainen ohjauskeinoympäristö',
      href: '/tietoja-pohjoismainen-ohjauskeinoymparisto',
    },
  ],
  nb: [
    {
      name: 'Naturbaserte løsninger',
      href: '/om-naturbaserte-losninger',
    },
    {
      name: 'Internasjonale mål og forpliktelser',
      href: '/om-internasjonale-mal-og-forpliktelser',
    },
    {
      name: 'Nordisk politisk landskap',
      href: '/om-nordisk-politisk-landskap',
    },
  ],
}

export const navItems = {
  en: [
    { name: 'All Advice', href: '/all-advice' },
    { name: 'About', href: '/about-guide' },
  ],
  fi: [
    { name: 'Kaikki ohjeet', href: '/kaikki-ohjeet' },
    { name: 'Tietoa', href: '/tietoja' },
  ],
  nb: [
    { name: 'Alle Råd', href: '/alle-rad' },
    { name: 'Om', href: '/om-veilederen' },
  ],
}
